export default __webpack_public_path__ + "static/media/bateria3tom.bc70cadb.png";